/********************************************************************************************************************************
 * Este fichero contiene los componentes customizados de formio que se servirán a la creación del formulario a través de FormEdit
********************************************************************************************************************************/
import selectSimple from './selectSimpleComponentFormio/selectSimpleComponentDefinitionFormio';
import selectAutocomplete from './selectAutocompleteComponentFormio/selectAutocompleteComponentDefinitionFormio';

export default {
  //Nombre del componente, a traves del cual se llamará desde el "builder"
  selectSimple,
  selectAutocomplete 
};
